module.exports = __webpack_public_path__ + "static/img/fullscreen-image_ready-made-reports_768.61d2bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_ready-made-reports_768.png
// module id = wp6n
// module chunks = 0